import type { RouteObject } from 'react-router';
import { LawEnforcementRequestPage } from '../compliance/LawEnforcementRequestPage';
import { VnnicReportBatchPage } from '../compliance/vnnic/InternationalReportsPage';
import { VnnicSyncTransactionPage } from '../compliance/vnnic/SyncTransactionPage';
import { LegalLockPage } from '../market/compliance/LegalLockPage';
import { PolicyPage } from './PolicyPage';

/**
 * Detail routes (paths without a leading slash). The compliance area registers every one of
 * its detail pages here, including the ones whose list page lives in another area's folder.
 */
export const GOVERNANCE_ROUTES: RouteObject[] = [
  { path: 'compliance/policies/:key', element: <PolicyPage /> },
  { path: 'compliance/legal-locks/:id', element: <LegalLockPage /> },
  { path: 'compliance/law-enforcement-requests/:id', element: <LawEnforcementRequestPage /> },
  { path: 'compliance/vnnic/sync-transactions/:id', element: <VnnicSyncTransactionPage /> },
  { path: 'compliance/vnnic/international-reports/:id', element: <VnnicReportBatchPage /> },
];
